// extracted by mini-css-extract-plugin
export default {"containerBanner":"styles_containerBanner__DN6cu"};